import React from 'react';
import { Box, TextField, FormControl, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ProjectStyles from '../../../../styles/jss/components/apps/ProjectStyles';

const ProjectTableHeader = (props) => {
  const [search, setSearch] = React.useState('');
  const { classes, sortBySearch } = props;

  return (
    <Grid className={classes.actionContainer} container spacing={3}>
      <Grid item md={4} sm={12} xs={12}>
        <Box>
          <FormControl style={{ width: '100%' }}>
            <TextField
              id="standard-adornment-amount"
              label={'Search by Analysis Name'}
              name={'name'}
              variant={'outlined'}
              value={search}
              onChange={(e) => {
                sortBySearch(e.target.value);
                setSearch(e.target.value);
              }}
            />
          </FormControl>
        </Box>
      </Grid>
    </Grid>
  );
};

export default withStyles(ProjectStyles, { withTheme: true })(ProjectTableHeader);
